import { Button } from "@/components/ui/button";
import type { KnowledgeBase } from "@/types/knowledgeBase";
import { useEffect, useState } from "react";
import {
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "../ui/drawer";
import ActiveToggle from "./ActiveToggle";
import ChannelsSelect from "./ChannelsSelect";
import KnowledgeBaseInfoFields from "./KnowledgeBaseInfoFields";



interface KnowledgeBaseFormProps {
  type: "create" | "edit";
  knowledgeBase: KnowledgeBase;
  onClose: () => void;
  onSave: (knowledgeBase: KnowledgeBase) => void;
}

export default function KnowledgeBaseForm({
  type,
  knowledgeBase,
  onClose,
  onSave,
}: KnowledgeBaseFormProps) {
  const [formData, setFormData] = useState<KnowledgeBase>(knowledgeBase);
  const [selectedChannels, setSelectedChannels] = useState<string[]>(
    knowledgeBase.channels || []
  );


  const title =
    type === "create"
      ? "Criar Base de Conhecimento"
      : "Editar Base de Conhecimento";
  const description =
    type === "create"
      ? "Defina as informações básicas para esta base de conhecimento"
      : "Modifique as informações desta base de conhecimento";

  const handleChange = (field: keyof KnowledgeBase, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    if (!formData.name) return; // Basic validation
    onSave(formData);
  };

  const handleChannelChange = (selectedValues: string[]) => {
    setSelectedChannels(selectedValues);
  };

  useEffect(() => {
    setFormData({
      ...formData,
      channels: selectedChannels,
    });
  }, [selectedChannels]);

  return (
    <DrawerContent>
      <DrawerHeader>
        <DrawerTitle>{title}</DrawerTitle>
        <DrawerDescription>{description}</DrawerDescription>
      </DrawerHeader>
      <div className="grid gap-4 py-4">
        <KnowledgeBaseInfoFields
          name={formData.name}
          description={formData.description || ""}
          onChange={(field, value) =>
            handleChange(field as keyof KnowledgeBase, value)
          }
        />

        <ChannelsSelect
          selectedChannels={selectedChannels}
          onChange={handleChannelChange}
        />

        <ActiveToggle
          isActive={formData.isActive}
          onChange={(active) => handleChange("isActive", active)}
        />
      </div>
      <DrawerFooter>
        <Button onClick={handleSubmit} disabled={!formData.name}>
          {type === "create" ? "Criar" : "Salvar"}
        </Button>
        <Button variant="outline" onClick={onClose}>
          Cancelar
        </Button>
      </DrawerFooter>
    </DrawerContent>
  );
}
